export const PassCurrentColor = {
    props: ['currentColor'],
    render() {
        return this.$createElement('div', {}, [this.$slots.default]);
    }
};

export const getPredefineColors = (showAlpha) => [
    '#ffffff',
    '#000000',
    // '#333333',
    '#ccf4fe',
    '#caddff',
    '#bfb5fe',
    '#d7b6ff',
    '#edbfdd',
    '#ffcec1',
    '#fff7d3',
    '#e1f0c3',
    '#66e1ff',
    '#69a0ff',
    '#6a55ff',
    '#a155ff',
    '#ff845f',
    '#ffc165',
    '#fee474',
    '#bfdf74',
    '#9b9b9b',
    '#1cd0ff',
    '#1067ff',
    '#7100fc',
    '#de1990',
    '#ff3c03',
    '#fe9d12',
    '#ffd11a',
    '#a6db1d',
    '#0241b4',
    '#4701a2',
    '#9c0060',
    '#ac0102',
    '#b06904',
    '#ba9508',
    '#739f00',
    '#066892',
    '#19d1ff'
].concat(
    showAlpha ? [
        'rgba(255, 69, 0, 0.68)',
        'hsva(120, 40, 94, 0.5)',
        'hsla(209, 100%, 56%, 0.73)'
    ] : []
);

export const ColorPickerIcon = {
    render(h) {
        return h('svg',
            {
                attrs: { viewBox: '0 0 16 16' }
            },
            [
                h('path', {
                    attrs: {
                        d: 'M10.7578125,8.4234375 L14.009375,4.5984375 C14.6625,3.83125 14.56875,2.678125 13.8015625,2.0265625 L13.10625,1.434375 C12.3375,0.78125 11.184375,0.875 10.5328125,1.64375 L7.28125,5.4671875 C7.175,5.5921875 7.0890625,5.7265625 7.0234375,5.8671875 L6.615625,5.49375 C6.3375,5.2390625 5.903125,5.2578125 5.6484375,5.5375 C5.39375,5.815625 5.4125,6.25 5.6921875,6.5046875 L6.23125,6.9984375 C6.109375,7.0609375 5.9765625,7.1609375 5.9765625,7.1609375 L2.9640625,10.603125 C2.9640625,10.603125 2.6796875,10.959375 2.5359375,11.3515625 C2.375,11.79375 2.375,12.253125 2.55,12.728125 C1.9890625,12.8 1.55625,13.278125 1.55625,13.859375 C1.55625,14.4890625 2.0671875,15 2.696875,15 C3.2953125,15 3.784375,14.540625 3.8328125,13.9546875 C4.3265625,14.11875 4.7484375,14.078125 5.16875,13.878125 C5.4984375,13.721875 5.75625,13.44375 5.75625,13.44375 L9.15,9.6703125 L9.7296875,10.2015625 C10.009375,10.45625 10.4421875,10.4375 10.696875,10.159375 C10.9515625,9.88125 10.9328125,9.446875 10.653125,9.1921875 L10.2609375,8.8328125 C10.4453125,8.728125 10.6140625,8.5921875 10.7578125,8.4234375 Z M8.5609375,9.2828125 C7.8515625,10.103125 5.2546875,13.034375 5.2546875,13.034375 C5.2546875,13.034375 5.0546875,13.2578125 4.8328125,13.3546875 C4.5234375,13.4890625 4.125,13.4484375 3.853125,13.3265625 C3.7734375,13.290625 3.6859375,13.234375 3.6,13.165625 C3.53125,13.0765625 3.45,12.996875 3.3578125,12.93125 C3.278125,12.8390625 3.209375,12.740625 3.165625,12.6453125 C3.0015625,12.296875 2.99375,11.89375 3.05,11.6703125 C3.11875,11.403125 3.2734375,11.140625 3.2734375,11.140625 L6.434375,7.5046875 C6.434375,7.5046875 6.5234375,7.4078125 6.55625,7.2984375 L8.628125,9.1953125 C8.609375,9.2234375 8.5875,9.2546875 8.5609375,9.2828125 L8.5609375,9.2828125 Z'
                    }
                })
            ]
        );
    }
};